import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useGetLink, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import hideAndShowFilterHandler from "@tSurya/Handlers/HideAndShowFilterHandler";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import parse from "html-react-parser";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    noSearchContent = "noSearchContent",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.noSearchContent]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = {
    clearAllProductFilters,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SurTabularDataStyles {
    container?: InjectableCss;
}
export const tabularDataStyles: SurTabularDataStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        `,
    },
};

const styles = tabularDataStyles;

const SurProductNoSearch: React.FC<Props> = ({ fields, clearAllProductFilters }) => {
    return (
        <StyledWrapper {...styles.container}>
            {parse(fields.noSearchContent, parserOptions)}
            <Button variant="secondary" onClick={() => clearAllProductFilters()}>
                {translate("Clear All")}
            </Button>
        </StyledWrapper>
    );
};

const SurInfoContentWidget: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SurProductNoSearch),
    definition: {
        group: "Common",
        displayName: "No search Content",
        fieldDefinitions: [
            {
                name: fields.noSearchContent,
                displayName: "Title",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 0,
            },
        ],
    },
};
export default SurInfoContentWidget;
